module.exports = __webpack_public_path__ + "img/skidlyvym.fb4194bb.png";